export enum Status {
  Pending = 'pending',
  Active = 'active',
	Expired = 'expired'
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
  filters?: string
}

export interface Admin {
  firstName: string
  imageId: string
  isActive: boolean
  lastName: string
	location?: string
	reinvite: boolean
  role: 'Admin'
  userId: string
}
